import type { Systems } from "@dealer-center/core-enviroment";

export interface navbarInterface {
  programs: string;
  links: {
    applications: string;
    navigation: string;
  };
  linksMenu: NavigationMenuItemInterface[];
  usermenu: {
    user: UserMenuItemsInterface;
    nav: NavigationMenuItemInterface[];
  };
}

export interface useNavbarItemsResultNew {
  navbarItemsResult: navbarInterface | null;
  navbarItemsLoading: boolean;
  navbarItemsError: string | null;
}

export type linkType = Systems | "new" | "external" | "none";

export interface LinkItem {
  label?: string;
  url?: string;
  linkType?: linkType;
}

export interface navMenuItemInterface {
  link: LinkItem;
  links?: navMenuItemInterface[];
}

export interface navMenuItemsInterfaceRoot {
  label?: string;
  internal?: boolean;
  links: navMenuItemInterface[];
}

export interface navbarItemsInterface {
  programs: string;
  links: {
    applications: string;
    navigation: string;
  };
  linksMenu: navMenuItemsInterfaceRoot[];
  usermenu: {
    user: userMenuItemsInterface;
    nav: navMenuItemsInterfaceRoot[];
  };
}

export interface useNavbarItemsResult {
  navbarItemsResult: navbarItemsInterface | null;
  navbarItemsLoading: boolean;
  navbarItemsError: string | null;
}
export interface userMenuItemsInterface {
  initials?: string;
  name?: string;
  serviceAccount: {
    name?: string;
  };
}

export interface usermenu {
  user: UserMenuItemsInterface;
  nav: NavigationMenuItemInterface[];
}

export interface UserMenuItemsInterface {
  name?: string;
}
export type NavigationMenuItemInterfaceNavigateLinkType =
  | "navigate"
  | "redirect"
  | "open";

export type NavigationMenuItemInterfaceHeaderLinkType = "header";

export type NavigationMenuItemInterfaceParentLinkType = "parent";

export type NavigationlinkType =
  | NavigationMenuItemInterfaceNavigateLinkType
  | NavigationMenuItemInterfaceHeaderLinkType
  | NavigationMenuItemInterfaceParentLinkType;

export type NavigationMenuItemInterface =
  | NavigationMenuItemInterfaceHeader
  | NavigationMenuItemInterfaceNavigate
  | NavigationMenuItemInterfaceParent;

export interface NavigationMenuItemInterfaceHeader {
  label: string;
  linkType: NavigationMenuItemInterfaceHeaderLinkType;
}

export interface NavigationMenuItemInterfaceNavigate {
  label: string;
  link: string;
  linkType: NavigationMenuItemInterfaceNavigateLinkType;
}

export interface NavigationMenuItemInterfaceParent {
  label: string;
  linkType: NavigationMenuItemInterfaceParentLinkType;
  links: NavigationMenuItemInterface[];
}

export const isNavigationMenuItemInterfaceHeader = (
  item: NavigationMenuItemInterface
): item is NavigationMenuItemInterfaceHeader => {
  return (item as NavigationMenuItemInterfaceHeader).linkType === "header";
};

export const isNavigationMenuItemInterfaceParent = (
  item: NavigationMenuItemInterface
): item is NavigationMenuItemInterfaceParent => {
  return (item as NavigationMenuItemInterfaceParent).linkType === "parent";
};

export const isNavigationMenuItemInterfaceNavigate = (
  item: NavigationMenuItemInterface
): item is NavigationMenuItemInterfaceNavigate => {
  return (item as NavigationMenuItemInterfaceNavigate).link !== undefined;
};
